export const JOHN_DEERE_CLIENT_ID = import.meta.env.VITE_JOHN_DEERE_CLIENT_ID;

export const JOHN_DEERE_REDIRECT_URI = import.meta.env.VITE_JOHN_DEERE_REDIRECT_URI;

export const JOHN_DEERE_AUTH_URL =
    'https://signin.johndeere.com/oauth2/aus78tnlaysMraFhC1t7/v1/authorize';

export const JOHN_DEERE_TOKEN_URL =
    'https://signin.johndeere.com/oauth2/aus78tnlaysMraFhC1t7/v1/token';

export const JOHN_DEERE_CONNECTION_API = '/api/john-deere/connection';

export const JOHN_DEERE_SCOPES = ['org2', 'ag2', 'ag3', 'offline_access'];

export const JOHN_DEERE_API_BASE_URL = import.meta.env.VITE_JOHN_DEERE_API_BASE_URL;

export const JOHN_DEERE_STATE_KEY = 'johnDeereOAuthState';
